const scopes = {
  accounts: "accounts",
  locations: "locations",
  allUsersBasic: "allUsersBasic",
  usersByLocation: "usersByLocation",
  userById: "userById",
  userByIdWithTherapies: "userByIdWithTherapies",
  workPlans: "workPlans",
  weeklyWorkDays: "weeklyWorkDays",
};

export const userKeys = {
  accounts: {
    scope: scopes.accounts,
    all: () => [scopes.accounts] as const,
    detail: (locationId: string) => [scopes.accounts, { locationId }] as const,
  },
  
  allUsersBasic: {
    scope: scopes.allUsersBasic,
    all: (withDeleted: boolean = false) => [scopes.allUsersBasic, { withDeleted }] as const,
  },

  usersByLocation: {
    scope: scopes.usersByLocation,
    all: () => [scopes.usersByLocation] as const,
    detail: (locationId: string) => [scopes.usersByLocation, { locationId }] as const,
  },
 
  locations: {
    scope: scopes.locations,
    all: () => [scopes.locations] as const,
  },
 
  userById: {
    scope: scopes.userById,
    detail: (userId: string) => [scopes.userById, { userId }] as const,
  },

  userByIdWithTherapies: {
    scope: scopes.userByIdWithTherapies,
    detail: (userId: string) => [scopes.userByIdWithTherapies, { userId }] as const,
  },

  workPlans: {
    scope: scopes.workPlans,
    all: () => [scopes.workPlans] as const,
    detail: (userId: string) => [scopes.workPlans, { userId }] as const,
  },

  weeklyWorkDays: {
    scope: scopes.weeklyWorkDays,
    all: () => [scopes.weeklyWorkDays] as const,
    byUser: (userId: string) => [scopes.weeklyWorkDays, "byUser", { userId }] as const,
    byWorkPlan: (userId: string, workPlanId: number) => 
      [scopes.weeklyWorkDays, "byWorkPlan", { userId, workPlanId }] as const,
  },
};